// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer-module--footer--2r2aa","h4":"footer-module--h4--19fB8","info":"footer-module--info--2pV1S"};